// extracted by mini-css-extract-plugin
export var adjacentSlide = "_nz-9";
export var arrowButtonContainer = "_nz-5";
export var arrowButtonIcon = "_nz-6";
export var carouselArrowButton = "_nz-2";
export var carouselElementContainer = "_nz-1";
export var currentSlide = "_nz-8";
export var left = "_nz-3";
export var otherSlide = "_nz-a";
export var productCarouselContainer = "_nz-0";
export var right = "_nz-4";
export var sliderOverflow = "_nz-7";